<template>
  <div class="wd-container mt-0">
      <div class="container  mt-50">
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
            <div class="card">
            <article class="card-body">
                <img src="/img/icons/logo.png" alt="Los Angeles" style="width:50%;">
                <hr>
                <h5 class="card-title wd-login-header" style="margin-bottom:30px;">Reset Password</h5>
                <div class="form-group">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input type="password" id="exampleInputPassword1" v-model="userPassword" class="form-control"
                         placeholder="Enter new password" ref="pass"
                         v-on:keyup.enter="onLogin()">
                </div>
                </div>
                <div class="form-group">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input type="password" id="exampleInputPassword1" v-model="userConfirmPassword" class="form-control" ref="conPass"
                         placeholder="Enter confirm password"
                         v-on:keyup.enter="onLogin()">
                </div>
                </div>
                <div class="clearfix"></div>
                <div class="form-group">
                <button type="submit" class="btn btn-login " v-on:click="onLogin" > Submit </button>
                </div>
            </article>
            </div>
            </div>
            <div class="col-sm"></div>
        </div>
      </div>
 </div>
</template>

<script>
import CommonConstants from '@/constants/constants.js'
import Vue from 'vue';
export default {
name: 'Login',
    data() {
      return {
        constants: CommonConstants,
        userEmail: '',
        userPassword: '',
        userConfirmPassword: '',
      }
    },
    methods: {
      onLogin: function () {
        let self = this;
        let flag = false;
        if (self.userPassword == '') {
           Vue.$toast.error('Please enter password', {
            position: 'top'
            });
          this.$refs['pass'].focus()
          flag = true;
        }
        if (self.userConfirmPassword == '' && flag != true) {
          Vue.$toast.error('Please enter confirm password', {
            position: 'top'
            });
          this.$refs['conPass'].focus()
          flag = true;
        }
        if (self.userPassword && self.userPassword.length <= 5 && flag != true) {
          // this.error.push("New password length must be 6 or more characters");
           Vue.$toast.error('Password length must be 6 or more characters', {
            position: 'top'
            });
          this.$refs['pass'].focus()
          flag = true;
        }
        if (self.userConfirmPassword && self.userConfirmPassword.length <= 5 && flag != true) {
          // this.error.push("Confirm password length must be 6 or more characters");
           Vue.$toast.error('Password length must be 6 or more characters', {
            position: 'top'
            });
          this.$refs['conPass'].focus()
          flag = true;
        }
        if (self.userPassword != self.userConfirmPassword && flag != true) {
          // this.error.push("New Password and confirm password will be same");
           Vue.$toast.error('Confirm password did not match', {
            position: 'top'
            });
          flag = true;
        }
        if (!flag) {
          let request = {
            'password': self.userPassword
          }
          axios.post(self.constants.api_url + 'auth/reset/' + self.$route.params.token + '/' + self.$route.params.email, request)
            .then(function (response) {
              if (response.data.flag) {
                Vue.$toast.success('Password Reset successfully', {
                position: 'top'
                });
                self.$session.destroy();
                self.$router.push("/login")
              }
              else {
                Vue.$toast.error(response.data.message, {
                position: 'top'
                });
              }
            }).catch(function (error) {
            self.$toasted.show(error, self.errorToast)
            Vue.$toast.error(error, {
              position: 'top'
              });
          })
        }
        else {

        }
      }
    }
}
</script>

<style>

</style>
